import React, { useEffect, useMemo, useState } from 'react';
import { doc, getAggregateFromServer, getDocs, orderBy, query, sum, updateDoc, where } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { TextField, MenuItem } from '@mui/material';
import { Title } from './../../../../components/Title/Title';
import { Header } from './../../../../components/Header/Header';
import SearchInput from '../../../../components/SearchInput/SearchInput';
import { citiesRef, couriersNewRef } from '../../../../utils/collectionRefs';
import { fieldsToSearchCourier } from './constants';
import BalanceCard from '../../../../components/BalanceCard/BalanceCard';
import OrderGrid from '../../../../components/OrderGrid ';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import { getCourierColumn } from './helpers/getCourierColumn';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import NoteAltRoundedIcon from '@mui/icons-material/NoteAltRounded';
import './scss/Couriers.scss';
import CustomDialog from '../../../../components/CustomDialog/CustomDialog';

const CouriersTest2 = ({ pageTitle }) => {
  const [couriers, setCouriers] = useState(null);
  const [cities, setCities] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalBalance, setTotalBalance] = useState(0)
  const [search, setSearch] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [selectedCourierId, setSelectedCourierId] = useState(null);
  const navigate = useNavigate();

  const userType = localStorage.getItem('userType');

  const fetchBalanceOfCouriers = async (filterQuery = couriersNewRef) => {
    try {
      const querySnapshot = await getAggregateFromServer(filterQuery, {
        balance: sum('balance')
      });
      setTotalBalance({ ...querySnapshot.data() })
    } catch (error) {
      console.error(error);
    }
  }

  const fetchingCouriers = async () => {
    try {
      setLoading(true)
      const q = query(couriersNewRef, orderBy('balance', 'desc'), where('active', '==', true))
      const querySnapshot = await getDocs(q);
      const couriersData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setCouriers(couriersData);
    } catch (error) {
      console.error('Error fetching couriers:', error);
    } finally {
      setLoading(false)
    }
  };

  const fetchCities = async () => {
    try {
      const querySnapshot = await getDocs(query(citiesRef, orderBy('name', 'asc')));
      const citiesData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setCities(citiesData);
    } catch (error) {
      console.error('Error setting cities:', error);
    }
  };

  const fetchInitialData = async () => {
    setLoading(true);
    await fetchBalanceOfCouriers();
    await fetchingCouriers();
    await fetchCities();
    setLoading(false);
  };

  useEffect(() => {
    fetchInitialData();
  }, []);



  const handleDeleteCourier = async (courierId) => {
    console.log("Deleting courier with ID:", courierId);
    try {
      await updateDoc(doc(couriersNewRef, courierId), { active: false });
      toast.success('Курьер успешно был удален', {
        autoClose: 2000,
        hideProgressBar: false,
      });
      // await fetchingCouriers()
    } catch (error) {
      toast.error('Произошла ошибка при удалении курьера:', {
        autoClose: 2000,
        hideProgressBar: false,
      });

      console.error('Error deleting courier:', error);
    } finally {
      handleClickClose()
    }
  };

  const getCouriers = async (query) => {
    try {
      setLoading(true)
      await fetchBalanceOfCouriers(query)
      const data = await getDocs(query);
      const newCouriers = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
      setCouriers(newCouriers);
    } catch (error) {
      console.error('Error fetching couriers:', error);
    } finally {
      setLoading(false)
    }
  };

  const sortOrderBy = (field, value) => {
    const sortQuery =
      value === 'Все'
        ? couriersNewRef
        : query(couriersNewRef, orderBy('balance', 'desc'), where(field, '==', value));
    getCouriers(sortQuery);
  };

  const courierCitySort = (event) => sortOrderBy('city', event.target.value);

  const handleSearchCourier = (e) => {
    setSearch(e.target.value.toLowerCase().trim());
  };

  const handleClickOpen = (courierId) => {
    setSelectedCourierId(courierId);
    setOpenDeleteModal(true);
  };

  const handleClickClose = () => {
    setSelectedCourierId(null);
    setOpenDeleteModal(false);
  };

  const filteredCouriers = useMemo(() => {
    if (!couriers) return { filteredCouriers: [], balance: 0, };
    const filteredCouriers = couriers.filter((courier) =>
      fieldsToSearchCourier.some((field) => {
        const value = courier[field];
        return value && value.toLowerCase().includes(search.toLowerCase());
      })
    );
    const totalBalance = filteredCouriers.reduce((sum, courier) => sum + (courier.balance || 0), 0)

    return { filteredCouriers, totalBalance };
  }, [couriers, search]);

  const actionsConfig = [
    {
      title: 'Редактировать',
      icon: <NoteAltRoundedIcon style={{ color: '#000b1f' }} />,
      handler: (params) => navigate(`/courier/update/${params.id}`),
      visible: userType === 'Админ',
    },
    {
      title: 'Удалить',
      icon: <DeleteRoundedIcon style={{ color: '#000b1f' }} />,
      handler: (params) => handleClickOpen(params.id),
      visible: userType === 'Админ',
    },
  ];

  const columns = getCourierColumn({ actionsConfig: actionsConfig, path: '/couriersTest2/details' })

  return (
    <>
      <div className='containerr'>
        <Helmet>
          <title>{pageTitle}</title>
        </Helmet>
        <Header previous='Cтатистика' initial='Список курьеров (TЕСТ 2)' />
        <Title
          title={'Список курьеров (TЕСТ 2)'}
          icon={<AssignmentRoundedIcon fontSize='24' />}
        />
        <div className='container-inner'>
          <div className='courier-list-header'>
            <div className='orders-sorting-header'>
              <div className='couriers-search-form'>
                <SearchInput
                  label='Поиск по курьерам'
                  placeholder='Имя, фамилия, номер, тип, город'
                  variant='standard'
                  onChange={handleSearchCourier}
                />
                <div className='order-sort'>
                  <TextField
                    id='outlined-select-currency'
                    select
                    label='По городу'
                    fullWidth
                    size='small'
                    defaultValue=''
                    onChange={courierCitySort}
                  >
                    <MenuItem value='Все'>Все</MenuItem>
                    {cities?.map((option) => (
                      <MenuItem key={option.name} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>
            </div>
            <BalanceCard
              title='Общий баланс курьеров'
              value={search ? filteredCouriers?.totalBalance : totalBalance?.balance || 0}
              icon={MonetizationOnRoundedIcon}
              iconColor='#10B981'
              borderColor='#10B981'
            />
          </div>
          <div className='orders-card-wrapper'>
            <div className='orders-card-header'>
              <div className='orders-card-parent'>
                {/* <div className='couriers-card-parent__btns'>
                  {userType === 'Админ' && (
                    <Button variant='black-contained' onClick={() => navigate('/courier/add')}>
                      Создать курьера +
                    </Button>
                  )}
                  <ExportCouriersToExcelButton data={couriers} headers={headers} fileName='Список курьеров' />
                </div> */}
              </div>
            </div>

            <OrderGrid
              orders={filteredCouriers.filteredCouriers || couriers}
              columns={columns}
              loading={loading}
              size={20}
            />


          </div>
        </div>
      </div>
      <CustomDialog
        open={openDeleteModal}
        onClose={handleClickClose}
        event={() => handleDeleteCourier(selectedCourierId)}
        text='Вы уверены что хотите удалить курьера?'
        btnText='Удалить'
      />
    </>
  );
};

export default CouriersTest2;
